/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Task16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M4.25 1v.778c0 1.232.922 2.148 2.09 2.226l.16.005h3c1.189 0 2.162-.862 2.244-2.065l.006-.166V1h.75A1.5 1.5 0 0114 2.5v11a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 012 13.5v-11A1.5 1.5 0 013.5 1h.75zm6.53 5.672a.73.73 0 00-.976-.075l-.084.075-2.47 2.45-.97-.894a.73.73 0 00-1.06 0 .8.8 0 00-.073 1.013l.073.087 1.5 1.444a.73.73 0 00.976.075l.084-.075 3-3a.798.798 0 000-1.1zM10.25 1v.778a.768.768 0 01-.648.77l-.102.008h-3a.76.76 0 01-.743-.673l-.007-.105V1h4.5z"
        />
    </AccessibleSVG>
);

export default Task16;
